import { DropdownMenuItem } from 'src/common/DropdownMenu/DropdownMenuItem';
import { DropdownMenuSeparator } from 'src/common/DropdownMenu/DropdownMenuSeparator';
import { DropdownSubmenu } from 'src/common/DropdownMenu/DropdownSubmenu';
import {
  AssignmentRead,
  DispatchTripRead,
  useAssignmentsListQuery,
} from 'src/common/external/bambi-api/bambiApi';

import { DriverAssignmentMenuAction } from './DriverAssignmentMenuAction';

export function DriverAssignmentMenu({ trip }: { trip: DispatchTripRead }) {
  // We only care about assignments containing the pickup time,
  // dropoff time does not need to be within the assignment range
  // for the purposes of this menu. This is specifically important
  // when we have a will-call trip scheduled for pickup at 23:59,
  // and we want to return full-day assignments that end at 23:59,
  // but not the next morning assignment that starts at 00:00.
  const { data: assignments, isLoading: assignmentsLoading } =
    useAssignmentsListQuery({
      containsTimestamp: trip.scheduled_pickup_at,
    });

  const assignmentsWithoutCurrentAssignment =
    assignments?.results.filter(
      (assignment: AssignmentRead) => assignment.id !== trip.assignment_id
    ) || [];

  const isAssigned = !!trip.assignment_id;
  return (
    <DropdownSubmenu triggerText={isAssigned ? 'Reassign' : 'Assign'}>
      <DropdownMenuItem>Please select a driver</DropdownMenuItem>
      <DropdownMenuSeparator />
      {assignmentsLoading && (
        <DropdownMenuItem>Loading Available Drivers...</DropdownMenuItem>
      )}
      {!assignmentsLoading &&
        assignmentsWithoutCurrentAssignment &&
        assignmentsWithoutCurrentAssignment.length === 0 && (
          <div className="max-w-[325px] ">
            <DropdownMenuItem>
              There are no {isAssigned ? 'other ' : ''}available drivers for
              this trip.
            </DropdownMenuItem>
          </div>
        )}
      {assignmentsWithoutCurrentAssignment &&
        assignmentsWithoutCurrentAssignment.map(
          (assignment: AssignmentRead) => (
            <DriverAssignmentMenuAction
              assignment={assignment}
              trip={trip}
              key={assignment.id}
            />
          )
        )}
    </DropdownSubmenu>
  );
}
